import * as React from 'react'
import { Button as ButtonBase, ButtonProps as ButtonPropsBase } from '@chakra-ui/react'

export type ButtonProps = ButtonPropsBase & {}

const Button: React.FC<ButtonProps> = ({ onClick, onMouseEnter, children, ...others }) => {
  const handleClick = () => {
    if (onClick) onClick()
  }

  const handleHover = () => {
    if (onMouseEnter) onMouseEnter()
  }

  return (
    <>
      <ButtonBase onMouseEnter={handleHover} onClick={handleClick} {...others}>
        {children}
      </ButtonBase>
    </>
  )
}

export default Button
